import { ApiButton, Button, Dialog, DialogActions, DialogContent, DialogTitle } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { makeStyles } from 'tss-react/mui';
import { candidateService } from '../../../../api';

export interface IDialogStateHandler {
  isDeleteDraftDialogOpen: boolean;
  setDeleteDraftDialogOpen: (arg: boolean) => void;
  setProceedSupplementaryModal: (arg: boolean) => void;
  setDeleteUuid: (arg: string) => void;
  setDeleteExamType: (arg: string) => void;
}

interface DeleteDraftDialogProps {
  dialogStateHandler: IDialogStateHandler;
  draftId: string;
  queryKeyToInvalidate?: string;
}

const useStyles = makeStyles()((theme) =>
({
  container: {
    alignItems: 'center',
  },
}));

const DeleteDraftDialog = ({
  dialogStateHandler,
  draftId,
  queryKeyToInvalidate,
}: DeleteDraftDialogProps) => {
  const { isDeleteDraftDialogOpen, setDeleteDraftDialogOpen } = dialogStateHandler;
  const { t } = useTranslation();
  const { classes } = useStyles();
  const queryClient = useQueryClient();
  const deleteDraftHandler = (uuid: string) => {
    deleteDraft.mutate(uuid);
  };
  const deleteDraft = candidateService.exam.candidate.useDeleteExamRegistrationDraft(
    (_res) => {
      if (queryKeyToInvalidate) {
        queryClient.invalidateQueries(queryKeyToInvalidate);
      }
    },
    (_err) => {
      // do nothing
    },
    () => {
      setDeleteDraftDialogOpen(false);
      deleteDraft.reset();
    }
  );

  return (
    <Dialog open={isDeleteDraftDialogOpen} maxWidth="sm">
      <DialogTitle>{t('exam->>ViewRegisteredExamsListing.DeleteDraft')}</DialogTitle>
      <DialogContent>{t('exam->>ViewRegisteredExamsListing.DeleteDraftDescription')}</DialogContent>
      <DialogActions>
        <Button
          id="button-cancel"
          type="button"
          variant="text"
          onClick={() => setDeleteDraftDialogOpen(false)}
        >
          {t('exam->>ViewRegisteredExamsListing.Cancel')}
        </Button>
        <ApiButton
          id="button-proceed-delete-draft"
          status={deleteDraft.status}
          variant="contained"
          onClick={() => deleteDraftHandler(draftId)}
        >
          {t('exam->>ViewRegisteredExamsListing.Proceed')}
        </ApiButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDraftDialog;
